import { apiBaseUrl } from './api';

export const fetchCloudinarySignature = body => {
  const url = `${apiBaseUrl()}/api/cloudinary-signature`;

  return window
    .fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body || {}),
    })
    .then(res => {
      if (res.status >= 400) {
        return res.json().then(data => {
          let e = new Error();
          e = Object.assign(e, data);
          throw e;
        });
      }
      return res.json();
    });
};

export const deleteCloudinaryAsset = body => {
  const url = `${apiBaseUrl()}/api/cloudinary-delete`;

  return window
    .fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body || {}),
    })
    .then(res => {
      if (res.status >= 400) {
        return res.json().then(data => {
          let e = new Error();
          e = Object.assign(e, data);
          throw e;
        });
      }
      return res.json();
    });
};

export const uploadCloudinaryImage = async ({ file, folder }) => {
  const signature = await fetchCloudinarySignature({ folder });
  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', signature.apiKey);
  formData.append('timestamp', signature.timestamp);
  formData.append('signature', signature.signature);
  formData.append('folder', signature.folder);

  const uploadUrl = `https://api.cloudinary.com/v1_1/${signature.cloudName}/image/upload`;
  const response = await window.fetch(uploadUrl, {
    method: 'POST',
    body: formData,
  });
  const data = await response.json();

  if (!response.ok) {
    const message = data?.error?.message || 'Cloudinary upload failed.';
    throw new Error(message);
  }

  return {
    url: data.secure_url,
    publicId: data.public_id,
    resourceType: data.resource_type,
    format: data.format || null,
    originalFilename: data.original_filename || file?.name || null,
    bytes: data.bytes,
  };
};
